/* eslint-disable react/prop-types */
import { TableCell, TableRow } from "@mui/material";
import React from "react";
import Table from "../../../../components/common/new/Table/Table";
import styles from "./FriendsReportsTable.styles";
import Typography from "../../../../components/common/new/Typography/Typography";

const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
  },
  small: {
    maxWidth: "6rem",
  },
  medium: {
    maxWidth: "10rem",
  },
  large: {
    minWidth: "10rem",
  },
  xlarge: {
    minWidth: "48rem",
  },
};

const FRIEND_SEAECH_TABLE_COL = [
  {
    displayName: "S.No",
    key: "s.no",
  },
  {
    displayName: "Friend Id",
    key: "friendId",
  },

  {
    displayName: "Name",
    key: "fullName",
  },
  {
    displayName: "Division Name",
    key: "division",
  },
  {
    displayName: "Date of First Meeting",
    key: "dateOfFirstMeeting",
  },
  {
    displayName: "Total Meetings Attended",
    key: "no.ofmettingAttend",
  },
  {
    displayName: "Last Meeting",
    key: "last_Meeting",
  },
  {
    displayName: "Introduced By",
    key: "introducedBy",
  },
  {
    displayName: "Introducer Mobile Number",
    key: "introducer_Phone",
  },
  {
    displayName: "Structure",
    key: "block",
  },
];

const getRows = ({ searchData, currentPage, pageSize }) =>
  searchData.map((friendInfo, index) => {
    const serialNumber = index + 1 + currentPage * pageSize;
    return (
      <TableRow>
        <TableCell style={tabelCellWidth.medium}>
          {" "}
          <Typography style={styles.typoghrphyStyle}>
            {serialNumber}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          {" "}
          <Typography style={styles.typoghrphyStyle}>
            {friendInfo.friendId}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.large}>
          {" "}
          <Typography style={styles.typoghrphyStyle}>
            {friendInfo.fullName}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          <Typography style={styles.typoghrphyStyle}>
            {friendInfo.divisionName}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          {" "}
          <Typography style={styles.typoghrphyStyle}>
            {friendInfo.firstDiscussionMeetingDate ?? "-"}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          {" "}
          <Typography style={styles.typoghrphyStyle}>
            {friendInfo.totalMeetingCount ?? "-"}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          {" "}
          <Typography style={styles.typoghrphyStyle}>
            {friendInfo.lastMeetingDate ?? "-"}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          {" "}
          <Typography style={styles.typoghrphyStyle}>
            {friendInfo.introducerName ?? "-"}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          {" "}
          <Typography style={styles.typoghrphyStyle}>
            {friendInfo.introducerMobileNumber ?? "-"}
          </Typography>{" "}
        </TableCell>

        <TableCell style={tabelCellWidth.xlarge}>
          <Typography style={styles.typoghrphyStyle}>
            {[
              friendInfo.areaName ?? "-",
              friendInfo.clusterName ?? "-",
              friendInfo.zoneName ?? "-",
              friendInfo.regionName ?? "-",
              friendInfo.chapterName ?? "-",
              friendInfo.districtName ?? "-",
              friendInfo.blockName ?? "-",
            ].join(" / ")}
          </Typography>
        </TableCell>
      </TableRow>
    );
  });

function ReportTable({
  searchData,
  currentPage,
  pageSize,
  onSelectMemberForTransfer,
  onMemberStatusToggle,
  onSelectMember,
  hasPermission,
  showStatusColumn,
}) {
  const columns = showStatusColumn
    ? FRIEND_SEAECH_TABLE_COL
    : FRIEND_SEAECH_TABLE_COL.filter(
        (c) => c.key !== "mobile" && c.key !== "address"
      );

  return (
    <div style={styles.container}>
      <Table
        scrollable
        columns={columns}
        rows={getRows({
          searchData,
          currentPage,
          pageSize,
          onSelectMemberForTransfer,
          onSelectMember,
          hasPermission,
          onMemberStatusToggle,
          showStatusColumn,
        })}
        tableBodyTheme="#F6F6F6"
        tableHeadCellStyle={{
          ...styles.tableHeadCells,
          textAlign: "center",
        }}
      />
    </div>
  );
}

export default ReportTable;
